import React, { useState } from "react";
import { connect } from "react-redux";
import { createStructuredSelector } from "reselect";

import { selectInvestmentStepData } from "store/user/investment/selectors";
import { setInvestmentStepData } from "store/user/investment/actions";
import { selectProjectDetails } from "store/project/selectors";

const pick = require("lodash/pick");

import { ADDRESS_TYPES, BANK_ACCOUNT_TYPES, PHONE_TYPES, USER_KYC_DETAILS_INPUT } from "constants/index";
import PersonalData from "components/KycModal/PersonalData";
import IdentificationData from "components/KycModal/IdentificationData";
import { useSideModalScrollToTop } from "hooks";
import { selectCurrenKYCStatus, selectKycFormData } from "store/user/kyc/selectors";
import { resetKYCFormData, setKYCStart, updateKYCFormData } from "store/user/kyc/actions";
import { KYCTileAPI } from "api";

const InvestmentUserDataStep = ({
    className = "",
    investmentStepData,
    setInvestmentStepData,
    kycData,
    onCloseButtonClick,
    open,
    backSlideEffect = "",
    setBackSlideEffect,
    updateKycForm,
    setKYCStartAPI,
    resetKycFormData,
    currentKYCStatus,
}) => {
    useSideModalScrollToTop();

    const [isKYCTileAPILoading, setKYCTileAPILoading] = useState(false);

    function onSubmitKycData(identification) {
        setKYCTileAPILoading(true);

        let kycDetails = { ...kycData.personal, ...identification };
        kycDetails = pick(kycDetails, USER_KYC_DETAILS_INPUT);

        const {
            TypeTitle,
            Country,
            BirthCountry,
            Nationality,
            MaritalStatus,
            IsEffectaCustomerInformationConfirmed,
            ...restWithoutTypeTitle
        } = kycDetails;

        const KYCTileAPIPayload = {
            ...restWithoutTypeTitle,
            TypeTitle: TypeTitle?.value,
            TypePhone: PHONE_TYPES.TypePhoneMobile,
            TypeBankAccount: BANK_ACCOUNT_TYPES.TypeBankAccountUserPrimary,
            TypeAddress: ADDRESS_TYPES.TypeAddressPrimary,
            Country: Country?.value,
            BirthCountry: BirthCountry?.value,
            Nationality: Nationality?.value,
            MaritalStatus: MaritalStatus?.value,
            IsEffectaCustomerInformationConfirmed: IsEffectaCustomerInformationConfirmed === true ? "true" : "false",
        };

        KYCTileAPI(KYCTileAPIPayload)
            .then((res) => {
                setKYCTileAPILoading(false);

                if (res?.data?.data?.kycTile?.user?.Email) {
                    setKYCStartAPI({
                        user: kycDetails,
                        currentKYCStatus,
                    });
                }
            })
            .catch(() => {
                setKYCTileAPILoading(false);
            });
    }

    let personalData = undefined;
    const userPersonalData = kycData && kycData.personal;
    // const isOldUserPersonalData = userPersonalData && Object.keys(userPersonalData).length;
    personalData = userPersonalData;

    let identificationData = undefined;
    identificationData = kycData && kycData.identification;

    if (
        personalData &&
        !(personalData.TypeGender === "female" || personalData.TypeGender === "male" || personalData.TypeGender === "diverse")
    ) {
        personalData.TypeGender = "";
    }

    return (
        <div className={`${className} investment-user-data-step`}>
            {investmentStepData.investmentData.userData.step === "indentificationData" ? (
                <IdentificationData
                    isSubmitButtonLoading={isKYCTileAPILoading}
                    isInvestment
                    backSlideEffect={backSlideEffect}
                    onCloseButtonClick={onCloseButtonClick}
                    data={identificationData}
                    open={open}
                    onSubmit={(values) => {
                        investmentStepData &&
                            setInvestmentStepData &&
                            setInvestmentStepData({
                                userData: { identificationData: values },
                            });
                        updateKycForm?.({
                            ...userPersonalData,
                            identification: values,
                        });
                        values && onSubmitKycData(values);
                    }}
                    onBack={() => {
                        setBackSlideEffect("step-slide-right");
                        investmentStepData &&
                            setInvestmentStepData &&
                            setInvestmentStepData({ userData: { step: "personalData" } });
                    }}
                />
            ) : (
                <PersonalData
                    backSlideEffect={backSlideEffect}
                    isRequiredBackButton
                    data={personalData}
                    open={open}
                    isInvestment
                    onBack={() => {
                        setBackSlideEffect("step-slide-right");
                        investmentStepData && investmentStepData.investmentData.userData.comingFrom
                            ? setInvestmentStepData(investmentStepData.investmentData.userData.comingFrom)
                            : setInvestmentStepData({ step: "investmentStartScreen" });
                        resetKycFormData();
                    }}
                    onSubmit={(values) => {
                        setBackSlideEffect("step-slide-left");
                        setInvestmentStepData &&
                            setInvestmentStepData({ userData: { step: "indentificationData", personalData: values } });
                        updateKycForm?.({
                            personal: values,
                        });
                    }}
                />
            )}
        </div>
    );
};

const mapStateToProps = createStructuredSelector({
    investmentStepData: selectInvestmentStepData,
    projectData: selectProjectDetails,
    kycData: selectKycFormData,
    currentKYCStatus: selectCurrenKYCStatus,
});

const mapDispatchToProps = (dispatch) => ({
    setInvestmentStepData: (data) => dispatch(setInvestmentStepData(data)),
    updateKycForm: (kycData) => dispatch(updateKYCFormData(kycData)),
    setKYCStartAPI: (kycData) => dispatch(setKYCStart(kycData)),
    resetKycFormData: () => dispatch(resetKYCFormData()),
});

export default connect(mapStateToProps, mapDispatchToProps)(InvestmentUserDataStep);
